<div class="algo-page">
  <header class="header">
    <h1 class="title">Algo Trading</h1>
    <span class="badge">Updated hourly</span>
    <div class="spacer"></div>
  </header>

  <!-- TABS -->
  <nav class="tabs">
    <div class="tab-list">
      <button *ngFor="let t of tabs"
              class="tab-btn"
              [class.active]="activeTab===t.key"
              (click)="setTab(t.key)">
        {{ t.label }}
      </button>
    </div>

    <button class="upload-btn" mat-raised-button color="primary"
            (click)="openUploadSystemDialog()">
      Upload system
    </button>
  </nav>
  <!-- Upload dialog -->
<div class="dialog-backdrop" *ngIf="showUpload" (click)="closeUpload()"></div>
<div class="dialog" *ngIf="showUpload" (click)="$event.stopPropagation()">
  <h3>Upload system</h3>

  <div class="dropzone"
       (dragover)="onDragOver($event)"
       (drop)="onDrop($event)">
    <p>Drag & drop a <strong>.js</strong> strategy here</p>
    <p>or</p>
    <button mat-stroked-button (click)="browseUpload(filePick)">Choose file</button>
    <input #filePick type="file" accept=".js" style="display:none" (change)="onFilePicked($event)">
  </div>

  <div class="actions">
    <button mat-button (click)="closeUpload()">Close</button>
  </div>
</div>


  <!-- DISCOVERY (default) -->
  <section class="discovery" *ngIf="activeTab!=='running'">
    <!-- Filters -->
    <form class="filters" *ngIf="filters" [formGroup]="filters">
      <div class="row">
        <label>
          <span>Market:</span>
          <select formControlName="market">
            <option>All</option>
          </select>
        </label>

        <label>
          <span>Running Time:</span>
          <select formControlName="runningTime">
            <option>All</option>
          </select>
        </label>

        <label>
          <span>ROI:</span>
          <select formControlName="roi">
            <option>All</option>
          </select>
        </label>

        <label>
          <span>Categories:</span>
          <select formControlName="category">
            <option>All</option>
          </select>
        </label>

        <button class="reset" type="button"
                (click)="filters.reset({market:'All',runningTime:'All',roi:'All',category:'All',sort:filters.value?.sort||'Recommended'})">
          Reset
        </button>

        <div class="sort">
          <span>Rank by:</span>
          <select formControlName="sort">
            <option>Recommended</option>
          </select>
        </div>

        <div class="spacer"></div>
      </div>
    </form>

    <!-- Table rendering what we currently have: id/name/size/createdAt/status -->
    <div class="table">
      <div class="thead">
        <div class="th w-56">#</div>
        <div class="th">Name</div>
        <div class="th w-140 right">Size</div>
        <div class="th w-220">Created</div>
        <div class="th w-120">Status</div>
        <div class="th w-160 right">Action</div>
      </div>

      <div class="tbody">
         <div class="tr" *ngFor="let r of discovery; let i = index">
          <div class="td w-56">{{ i + 1 }}</div>
          <div class="td">
            <div class="name">{{ r.icon || '' }} {{ r.name }}</div>
            <div class="sub">
              {{ r.symbol || '-' }}
              - {{ r.mode || 'SPOT' }}
              <ng-container *ngIf="r.venue">- {{ r.venue }}</ng-container>
              <ng-container *ngIf="r.frequencyLabel">- {{ r.frequencyLabel }}</ng-container>
            </div>
          </div>


          <div class="td w-140 right">
            {{ ((r.size ?? 0) / 1024) | number:'1.0-0' }} KB
          </div>

          <div class="td w-260 nowrap" title="{{ r.createdAt | date:'yyyy-MM-dd HH:mm:ss Z' }}">
             {{ r.createdAt | date:'yy-MM-dd HH:mm' }}
          </div>

          <div class="td w-120">
            <span class="badge"
                  [class.badge-running]="r.status==='running'"
                  [class.badge-stopped]="r.status!=='running'">
              {{ r.status || 'stopped' }}
            </span>
          </div>

          <div class="td w-160 right">
           <button mat-raised-button color="accent" (click)="openAllocate(r)">Allocate</button>
          </div>
        </div>

        <div class="empty" *ngIf="!discovery?.length">
          No systems yet — upload one to get started.
        </div>
      </div>
    </div>
  </section>

  <!-- RUNNING -->
<section class="running" *ngIf="activeTab==='running'">
  <div class="table">
    <div class="thead">
      <div class="th">Strategy</div>
      <div class="th w-140 right">Allocated</div>
      <div class="th w-140 right">P&amp;L</div>
      <div class="th w-220">Started</div>
      <div class="th w-160 right">Action</div>
    </div>

    <div class="tbody">
      <!-- bind to service stream -->
      <div class="tr" *ngFor="let s of (running$ | async) ?? []">
        <div class="td">{{ s.name || '—' }}</div>

        <!-- amount -> allocated -->
        <div class="td w-140 right">{{ s.amount ?? 0 }}</div>

        <!-- pnlUsd -> pnl -->
        <div class="td w-140 right"
             [class.positive]="(s.pnlUsd ?? 0) >= 0"
             [class.negative]="(s.pnlUsd ?? 0) < 0">
          {{ s.pnlUsd ?? 0 }}
        </div>

        <div class="td w-220">{{ s.startedAt | date:'yyyy-MM-dd HH:mm' }}</div>

        <!-- systemId -> runId -->
        <div class="td w-160 right">
          <button mat-stroked-button color="primary" (click)="stopSystem(s.systemId)">Stop</button>
          <button mat-stroked-button (click)="openWithdraw(s)" style="margin-left:8px;">Withdraw</button>
        </div>
      </div>

      <div class="empty" *ngIf="!((running$ | async)?.length)">
        No systems running yet.
      </div>
    </div>
  </div>
   <!-- Console Dock -->
  <div class="worker-console">
    <div class="console-header">
      <span>Algo Console</span>
      <button class="clear-btn" (click)="clearWorkerConsole()">Clear</button>
    </div>
    <pre id="worker-console-output">{{ workerLog }}</pre>
  </div>
</section>

  <!-- Inline allocate dialog -->
  <div class="dialog-backdrop" *ngIf="showAllocate" (click)="closeAllocate()"></div>
  <div class="dialog" *ngIf="showAllocate">
    <h3>Allocate Funds</h3>
    <form [formGroup]="allocationForm">
      <label>Amount</label>
      <input type="number" formControlName="amount" placeholder="0" />
      <div class="row">
        <div class="col">
          <label>API Key (optional)</label>
          <input type="text" formControlName="apiKey" />
        </div>
        <div class="col">
          <label>API Secret (optional)</label>
          <input type="password" formControlName="apiSecret" />
        </div>
      </div>
    </form>
    <div class="actions">
      <button mat-button (click)="closeAllocate()">Cancel</button>
      <button mat-raised-button color="primary" (click)="allocateConfirm()">Confirm</button>
    </div>
  </div>

  <!-- Inline withdraw dialog -->
  <div class="dialog-backdrop" *ngIf="showWithdraw" (click)="closeWithdraw()"></div>
  <div class="dialog" *ngIf="showWithdraw">
    <h3>Withdraw</h3>
    <form [formGroup]="withdrawForm">
      <label>Amount</label>
      <input type="number" formControlName="amount" placeholder="0" />
    </form>
    <div class="actions">
      <button mat-button (click)="closeWithdraw()">Cancel</button>
      <button mat-raised-button color="primary" (click)="confirmWithdraw()">Withdraw</button>
    </div>
  </div>
</div>


